import type { SVGProps } from "react";
const SvgSparkasseLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 354.126 460.684"
    {...props}
  >
    <path
      d="M177.063 0a58.515 58.515 0 0 0-23.235 4.807c-7.21 3.045-13.01 6.73-18.427 12.018-5.32 5.32-9.71 12.114-12.819 19.229-3.045 7.178-4.807 14.293-4.807 22.433s1.764 16.056 4.807 23.234c3.109 7.083 7.5 13.14 12.819 18.428 5.416 5.352 11.217 9.71 18.427 12.819 7.18 3.044 15.095 4.807 23.235 4.807 8.204 0 16.056-1.764 23.234-4.807 7.115-3.109 13.14-7.467 18.428-12.82 5.32-5.287 9.71-11.344 12.819-18.427 3.044-7.178 4.807-15.094 4.807-23.234 0-8.14-1.764-15.255-4.807-22.433-3.109-7.115-7.5-13.91-12.82-19.229-5.287-5.288-11.312-8.973-18.427-12.018A58.306 58.306 0 0 0 177.063 0ZM58.487 153.828c-8.14 0-15.255.898-22.433 4.006-7.18 3.077-13.877 7.5-19.229 12.82-5.32 5.32-8.973 12.05-12.018 19.228C1.7 196.997 0 204.175 0 212.315v129.793h271.603v36.053H0v23.235c0 8.172 1.73 16.056 4.807 23.234 3.045 7.18 6.73 13.076 12.018 18.428 5.352 5.288 12.05 9.742 19.229 12.819 7.178 3.108 14.293 4.807 22.433 4.807h237.152c8.14 0 15.255-1.697 22.433-4.807 7.21-3.077 13.94-7.531 19.229-12.82 5.352-5.351 9.71-11.248 12.819-18.427 3.108-7.178 4.006-15.062 4.006-23.234V271.603H82.523v-35.252h271.603v-24.036c0-8.14-.864-15.318-4.006-22.433-3.077-7.179-7.467-13.909-12.82-19.229-5.287-5.32-12.017-9.742-19.228-12.819-7.178-3.108-14.293-4.006-22.433-4.006z"
      style={{
        fill: "#e00",
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
      }}
    />
  </svg>
);
export default SvgSparkasseLogo;
